import { render, staticRenderFns } from "./SinglePatientModals.vue?vue&type=template&id=70501690&"
import script from "./SinglePatientModals.vue?vue&type=script&lang=js&"
export * from "./SinglePatientModals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports